<template>
  <el-dialog
    title="客户联系人"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
    :append-to-body="inner"
    :close-on-click-modal="false"
  >
    <el-form
      v-if="model"
      ref="form"
      label-width="70px"
      :model="model"
      :rules="formRules"
    >
      <el-form-item label="姓名" prop="name">
        <el-input
          size="small"
          v-model="model.name"
          placeholder="联系人名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="电话" prop="mobile">
        <el-input
          size="small"
          v-model="model.mobile"
          placeholder="联系人电话"
        ></el-input>
      </el-form-item>
      <el-form-item label="职务">
        <el-input
          size="small"
          v-model="model.duty"
          placeholder="联系人职务"
        ></el-input>
      </el-form-item>
      <el-form-item label="邮件">
        <el-input
          size="small"
          v-model="model.email"
          placeholder="联系人邮箱"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {
  createCustomerContact,
  updateCustomerContact,
} from '../service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    inner: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
    model() {},
  },
  data() {
    return {
      visible: this.show,
      formRules: {
        name: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' },
          {
            min: 1,
            max: 100,
            message: '长度在 1 到 10 个字符',
            trigger: 'blur',
          },
        ],
        mobile: [
          { required: true, message: '请输入联系人电话', trigger: 'blur' },
          {
            min: 5,
            max: 20,
            message: '请输入正确格式的电话号码',
            trigger: 'blur',
          },
        ],
      },
      submiting: false,
    }
  },
  created() {},

  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          if (this.model.id > 0) {
            let res = await updateCustomerContact(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createCustomerContact(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }
          this.submiting = false
          this.visible = false
        } else {
          this.submiting = false
          console.log('error submit!!')
        }
      })
    },
  },
}
</script>